import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLoader } = FiIcons;

const ProcessingModal = ({ isOpen, currentStep, steps }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className="bg-white rounded-2xl p-8 max-w-md w-full text-center"
          >
            <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiLoader} className="w-8 h-8 text-primary-600 animate-spin" />
            </div>
            
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Processing Your Project
            </h3>
            
            <div className="space-y-3">
              {steps.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0.3 }}
                  animate={{ 
                    opacity: index <= currentStep ? 1 : 0.3,
                    scale: index === currentStep ? 1.02 : 1
                  }}
                  className={`text-sm p-3 rounded-lg ${
                    index === currentStep 
                      ? 'bg-primary-50 text-primary-700 font-medium'
                      : 'text-gray-600'
                  }`}
                >
                  {step}
                </motion.div>
              ))}
            </div>
            
            <div className="mt-6 flex justify-center">
              <div className="flex space-x-1">
                {[0, 1, 2].map((i) => (
                  <motion.div
                    key={i}
                    animate={{
                      scale: i === currentStep ? 1.2 : 1,
                      opacity: i <= currentStep ? 1 : 0.3
                    }}
                    className="w-2 h-2 bg-primary-500 rounded-full"
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ProcessingModal;